import React from 'react';
import { CheckCircle2, Clock, Video, Gift, Users } from 'lucide-react';
const situatii = ['Simți că ai potențial, dar ceva din interior te oprește înainte să faci primul pas.', 'Ești într-o perioadă aglomerată sau copleșitoare și nu știi de unde să începi.', 'Ai momente în care știi ce trebuie să faci, dar o voce interioară îți spune că nu ești suficient de bun sau pregătit.', 'Eviți oportunități importante, o colaborare, un proiect pe cont propriu, o negociere, pentru că nu ai încredere că meriți sau că poți.', 'Nu știi ce vrei și simți că ai nevoie de claritate ca să te orientezi spre ceva ce ți se potrivește cu adevărat.', 'Treci prin momente grele și vrei să înveți să te susții singur, din interior, nu să depinzi de circumstanțe sau de alții.'];
const pasii = [{
  titlu: 'Înțeleg unde ești acum',
  descriere: 'Îmi spui cu ce te confrunți: o decizie, un blocaj, o perioadă grea sau pur și simplu o lipsă de direcție.'
}, {
  titlu: 'Identificăm resursele pe care le ai deja',
  descriere: 'Descoperim împreună curajul, determinarea, claritatea sau echilibrul pe care le-ai folosit deja în viața ta, fără să fi știut că le aveai.'
}, {
  titlu: 'Înveți să le activezi conștient',
  descriere: 'Îți arăt cum să accesezi aceste resurse ori de câte ori ai nevoie: când ești copleșit, când iei o decizie importantă sau când îți pierzi încrederea în tine.'
}, {
  titlu: 'Pleci cu un pas concret',
  descriere: 'La finalul sesiunii știi exact ce resursă să activezi și cum, indiferent de ce urmează în viața ta.'
}];
const CTA_LINK = 'https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform';
export function SesiuneCadou() {
  return <>
      {/* SECTION 1 - HERO */}
      <section className="bg-rise-white text-rise-black py-12 md:py-20 px-6 overflow-hidden" data-id="element-1055" data-mp="21gyinudrvhob">
        <div className="max-w-rise-content mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-1056" data-mp="26gkxg89915z8">
          {/* Text Content - centered on all viewports */}
          <div className="flex flex-col items-center text-center order-1" data-id="element-1057" data-mp="1iclex1lq95qi">
            <span className="font-dm-sans text-[13px] tracking-[0.2em] uppercase text-rise-gold mb-6 border border-rise-gold/40 px-4 py-2 rounded-full" data-id="element-1058" data-mp="1iepoo06b4yyp">
              Sesiune Cadou 1:1
            </span>

            <h1 className="font-playfair text-[36px] md:text-[52px] leading-[1.1] mb-6" data-id="element-1059" data-mp="18kz436dax8oa">
              Descoperă ce ai în tine ca să nu mai aștepți din exterior
            </h1>

            <p className="font-dm-sans text-[19px] text-rise-gray mb-10 leading-relaxed max-w-xl" data-id="element-1060" data-mp="ynaw3eqoq4o6">
              O sesiune de 45 de minute, online, în care identificăm împreună
              resursele pe care le-ai folosit deja toată viața fără să știi și
              înveți să le activezi conștient când ai nevoie de curaj, claritate
              sau echilibru. Fără presiune. Fără vânzare. Doar tu și ce ai în
              tine.
            </p>

            {/* Detalii sesiune */}
            <div className="grid grid-cols-2 gap-4 mb-10 w-full max-w-md" data-id="element-1061" data-mp="2rkydg0zn12yi">
              <div className="border border-rise-gold/30 rounded-xl p-4 text-left" data-id="element-1062" data-mp="2wjstiv680dex">
                <Clock className="w-5 h-5 text-rise-gold mb-2" data-id="element-1063" data-mp="31ardc4qf3tmx" />
                <p className="font-dm-sans text-[11px] uppercase tracking-wider text-rise-gray mb-1" data-id="element-1064" data-mp="31ddsoqjjvdfp">
                  Durată
                </p>
                <p className="font-playfair text-[18px] font-semibold" data-id="element-1065" data-mp="28nf38u1g1eai">
                  45 minute
                </p>
              </div>
              <div className="border border-rise-gold/30 rounded-xl p-4 text-left" data-id="element-1066" data-mp="2dlyoes87qm1t">
                <Video className="w-5 h-5 text-rise-gold mb-2" data-id="element-1067" data-mp="2ij8bi184qlmh" />
                <p className="font-dm-sans text-[11px] uppercase tracking-wider text-rise-gray mb-1" data-id="element-1068" data-mp="2mmwleqk8htaw">
                  Format
                </p>
                <p className="font-playfair text-[18px] font-semibold" data-id="element-1069" data-mp="3tzowea2gdugq">
                  Online, Zoom
                </p>
              </div>
              <div className="border border-rise-gold/30 rounded-xl p-4 text-left" data-id="element-1070" data-mp="egwl7tjuq15">
                <Gift className="w-5 h-5 text-rise-gold mb-2" data-id="element-1071" data-mp="3rlbcgbswxz2a" />
                <p className="font-dm-sans text-[11px] uppercase tracking-wider text-rise-gray mb-1" data-id="element-1072" data-mp="3rn4ibovpcf98">
                  Preț
                </p>
                <p className="font-playfair text-[18px] font-semibold text-rise-gold" data-id="element-1073" data-mp="5ed075yc4fg6">
                  CADOU
                </p>
              </div>
              <div className="border border-rise-gold/30 rounded-xl p-4 text-left" data-id="element-1074" data-mp="jc9x63gpanvd">
                <Users className="w-5 h-5 text-rise-gold mb-2" data-id="element-1075" data-mp="ee05w3y3k7f1" />
                <p className="font-dm-sans text-[11px] uppercase tracking-wider text-rise-gray mb-1" data-id="element-1076" data-mp="t47d1ninm40f">
                  Locuri
                </p>
                <p className="font-playfair text-[18px] font-semibold" data-id="element-1077" data-mp="o531wrc65w7g">
                  Max. 6 / lună
                </p>
              </div>
            </div>

            <a href={CTA_LINK} target="_top" data-id="element-1078" data-mp="y3jyq4xsh51f">
              Rezervă Sesiunea Ta Gratuită
            </a>

            <p className="font-dm-sans italic text-[13px] text-rise-gray mt-3" data-id="element-1079" data-mp="1gqt5i36bw27o">
              Locuri limitate. Sesiunile se ocupă în ordinea rezervărilor.
            </p>
          </div>

          {/* Image & Decorations */}
          <div className="relative w-full max-w-[280px] lg:max-w-md mx-auto lg:ml-auto order-2" data-id="element-1080" data-mp="17puydc0lfekv">
            {/* Concentric dashed circles */}
            <svg className="absolute -top-12 -right-12 w-64 h-64 text-rise-gold pointer-events-none hidden lg:block" viewBox="0 0 200 200" fill="none" stroke="currentColor" strokeWidth="0.6" data-id="element-1081" data-mp="y0jpnqhmcbxi">
              <circle cx="100" cy="100" r="95" strokeDasharray="3 5" data-id="element-1082" data-mp="oxsfrv4e5o7z" />
              <circle cx="100" cy="100" r="75" strokeDasharray="1 4" data-id="element-1083" data-mp="t29xzpv3rtgn" />
            </svg>

            {/* Sparkle / star */}
            <svg className="absolute -top-10 -left-10 w-20 h-20 text-rise-gold pointer-events-none" viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="0.6" data-id="element-1084" data-mp="f3sclyso6t1w">
              <path d="M25 5 L27 23 L45 25 L27 27 L25 45 L23 27 L5 25 L23 23 Z" data-id="element-1085" data-mp="2gy6mingyuo22" />
              <circle cx="25" cy="25" r="2" fill="currentColor" data-id="element-1086" data-mp="2cx4jrwnubtvc" />
            </svg>

            {/* Dot grid */}
            <svg className="absolute -bottom-12 -left-12 w-36 h-36 text-rise-gold/50 pointer-events-none hidden lg:block" viewBox="0 0 120 120" fill="none" data-id="element-1087" data-mp="27zcjofd1l1g2">
              <pattern id="sesiune-dots" x="0" y="0" width="16" height="16" patternUnits="userSpaceOnUse" data-id="element-1088" data-mp="30ojr63uh51dg">
                <circle cx="2" cy="2" r="1.2" fill="currentColor" data-id="element-1089" data-mp="2qosvhyu6ggbs" />
              </pattern>
              <rect width="120" height="120" fill="url(#sesiune-dots)" data-id="element-1090" data-mp="1kajur2uu7tuy" />
            </svg>

            {/* Bracket accents */}
            <svg className="absolute -top-5 -right-5 w-14 h-14 text-rise-gold pointer-events-none" viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="1.2" data-id="element-1091" data-mp="1fc8k4pwpxfbo">
              <path d="M50 0 L50 15 M50 0 L35 0" data-id="element-1092" data-mp="1f33j0eund5fm" />
            </svg>
            <svg className="absolute -bottom-5 -left-5 w-14 h-14 text-rise-gold pointer-events-none" viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="1.2" data-id="element-1093" data-mp="1juldql62u9s5">
              <path d="M0 50 L0 35 M0 50 L15 50" data-id="element-1094" data-mp="1stox7q95or76" />
            </svg>

            {/* Gold dots scattered */}
            <div className="absolute -top-3 right-16 w-2.5 h-2.5 rounded-full bg-rise-gold pointer-events-none" data-id="element-1095" data-mp="1xsjlh7pw77yo"></div>
            <div className="absolute -bottom-3 right-20 w-3 h-3 rounded-full bg-rise-gold pointer-events-none" data-id="element-1096" data-mp="3glfrfqsku7j"></div>

            {/* Offset borders */}
            <div className="absolute inset-0 border border-rise-gold/70 rounded-xl translate-x-4 translate-y-4 lg:translate-x-5 lg:translate-y-5 pointer-events-none" data-id="element-1097" data-mp="8ghm3lmyoxq9"></div>
            <div className="absolute inset-0 border border-rise-gold/30 rounded-xl translate-x-7 translate-y-1 lg:translate-x-8 lg:translate-y-2 pointer-events-none hidden lg:block" data-id="element-1098" data-mp="25exacuhbdotp"></div>

            <img src="https://cdn.magicpatterns.com/uploads/pG12JLChzvmkcCf8uS9D97/Teodora_1.jpg" alt="Teodora Trifu" className="w-full h-auto object-cover object-top rounded-xl shadow-lg relative z-10" data-id="element-1099" data-mp="2f3f5ow6tr3py" />
          </div>
        </div>
      </section>

      {/* SECTION 2 - PENTRU CINE ESTE */}
      <section className="bg-rise-anthracite text-rise-white py-12 md:py-20 px-6" data-id="element-1100" data-mp="20glw87jzks5o">
        <div className="max-w-rise-content mx-auto" data-id="element-1101" data-mp="1wco1e91p23if">
          <div className="text-center mb-16" data-id="element-1102" data-mp="3bu7po4wvpfx0">
            <h2 className="font-playfair text-[32px] md:text-[38px] mb-4" data-id="element-1103" data-mp="3bswhlswehm03">
              Această sesiune este pentru tine dacă...
            </h2>
            <p className="font-dm-sans text-rise-white max-w-2xl mx-auto text-[19px]" data-id="element-1104" data-mp="3fc55jhje498l">
              Recunoaște-te în oricare dintre aceste situații.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-1105" data-mp="3k95d5wvw1k1t">
            {situatii.map((situatie, index) => <div key={index} className="bg-rise-black p-8 md:p-[40px] rounded-xl border border-rise-gold/40 flex items-start gap-5 relative overflow-hidden" data-id="element-1106" data-mp="3acsfknx82m1s" data-mpi={index}>
                <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold/40" data-id="element-1107" data-mp="6wv3uajex61c"></div>
                <span className="font-playfair text-rise-gold text-[32px] leading-none shrink-0" data-id="element-1108" data-mp="3od38dwi3eapl">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <p className="font-dm-sans text-[19px] text-rise-white/85 leading-relaxed" data-id="element-1109" data-mp="3t9jxou112v49">
                  {situatie}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 3 - CE SE ÎNTÂMPLĂ ÎN SESIUNE */}
      <section className="bg-rise-white text-rise-black py-12 md:py-20 px-6" data-id="element-1110" data-mp="2bv1m7ol5v242">
        <div className="max-w-rise-content mx-auto" data-id="element-1111" data-mp="2fv3o9yut5xjv">
          <div className="text-center mb-16" data-id="element-1112" data-mp="2ftsla196sttt">
            <h2 className="font-playfair text-[32px] md:text-[38px] mb-4" data-id="element-1113" data-mp="21varpmwlon3z">
              Cum decurge sesiunea ta de 45 de minute
            </h2>
            <p className="font-dm-sans text-rise-gray max-w-2xl mx-auto text-[19px]" data-id="element-1114" data-mp="26x9twtgltdzc">
              Patru pași simpli, fără presiune, către claritate reală.
            </p>
          </div>

          <div className="relative" data-id="element-1115" data-mp="1wzdkq7788t3v">
            {/* Vertical connecting line on desktop */}
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-rise-gold/30 -translate-x-1/2" data-id="element-1116" data-mp="1j7p9e64sy8ny"></div>

            <div className="space-y-12 md:space-y-16" data-id="element-1117" data-mp="197onqdjgnggl">
              {pasii.map((pas, index) => <div key={index} className={`grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center ${index % 2 === 1 ? 'md:[&>div:first-child]:order-2' : ''}`} data-id="element-1118" data-mp="1e6rsrxzfxmok" data-mpi={index}>
                  {/* Step number side */}
                  <div className={`flex justify-center ${index % 2 === 1 ? 'md:justify-start' : 'md:justify-end'}`} data-id="element-1119" data-mp="qkz3k9binvup">
                    <div className="relative" data-id="element-1120" data-mp="zjjcwjv6st69">
                      <div className="w-24 h-24 md:w-32 md:h-32 rounded-full border border-rise-gold flex items-center justify-center bg-rise-white relative z-10" data-id="element-1121" data-mp="zirhb91lavfz">
                        <span className="font-playfair text-rise-gold text-[40px] md:text-[56px] leading-none" data-id="element-1122" data-mp="19h79lfccsar2">
                          {index + 1}
                        </span>
                      </div>
                      <div className="absolute inset-0 w-24 h-24 md:w-32 md:h-32 rounded-full border border-rise-gold/30 translate-x-2 translate-y-2" data-id="element-1123" data-mp="1ibvcwzydbid8"></div>
                    </div>
                  </div>

                  {/* Content side */}
                  <div className={`text-center ${index % 2 === 1 ? 'md:text-right' : 'md:text-left'}`} data-id="element-1124" data-mp="1s6x2ty0gwogv">
                    <h3 className="font-playfair text-[24px] md:text-[28px] font-semibold mb-3 text-rise-black" data-id="element-1125" data-mp="24c2pdyv6y5n8">
                      {pas.titlu}
                    </h3>
                    <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1126" data-mp="2e0kmo649hum4">
                      {pas.descriere}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="text-center mt-16 max-w-2xl mx-auto" data-id="element-1127" data-mp="2mzxvqxoh4h6b">
            <p className="font-playfair italic text-[22px] text-rise-gold mb-8" data-id="element-1128" data-mp="2s03pqki7ufrk">
              Fără vânzare. Fără presiune. Pleci cu claritate și cu ceva real pe
              care îl poți folosi de mâine.
            </p>
            <div className="flex justify-center" data-id="element-1129" data-mp="xnw3dvjyn77e">
              <a href={CTA_LINK} target="_top" data-id="element-1130" data-mp="12lnuwogp0rb2">
                Rezervă Sesiunea Ta Gratuită
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4 - CINE SUNT EU */}
      <section className="bg-rise-anthracite text-rise-white py-12 md:py-20 px-6 overflow-hidden" data-id="element-1131" data-mp="qbps3acy5lk8">
        <div className="max-w-rise-content mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center" data-id="element-1132" data-mp="lc3egzt7i3aw">
          <div className="order-2 md:order-2" data-id="element-1133" data-mp="ge1mfpdsytna">
            <h2 className="font-playfair text-[32px] md:text-[38px] mb-8" data-id="element-1134" data-mp="gb5oi11yg4yu">
              Cine te ghidează în această sesiune
            </h2>

            <div className="font-dm-sans text-[19px] text-rise-white/85 space-y-6 leading-relaxed" data-id="element-1135" data-mp="191ebq7bclfka">
              <p data-id="element-1136" data-mp="142bc52e501jp">
                Sunt <strong className="text-rise-gold" data-id="element-1137" data-mp="141ji3w06ubvj">Teodora Trifu</strong>,
                consilier pentru dezvoltare personală cu 9 ani de experiență în
                lucrul cu tineri. Folosesc metode experiențiale și creative
                pentru a ajuta oamenii să descopere ce au deja în interior și să
                treacă de la blocaj la acțiune.
              </p>
              <p data-id="element-1138" data-mp="1ciii73asxp3p">
                Am lucrat cu o kinetoterapeută care știa că poate vorbi în
                public, dar o voce interioară o oprea mereu. Am lucrat cu
                freelanceri care evitau proiecte mari de teamă că nu sunt
                suficient de buni. Cu tineri absolvenți blocați la primul pas.
                Cu artiști care refuzau colaborări internaționale din lipsă de
                încredere.
              </p>
              <p className="font-playfair italic text-rise-gold text-[22px] leading-snug" data-id="element-1139" data-mp="1va1i319j4n1i">
                Toți aveau resursele necesare. Pur și simplu nu știau că le au.
              </p>
              <p data-id="element-1140" data-mp="1lakeqqhr2l8p">
                De aceea ofer această sesiune: ca să descoperi ce ai în tine
                înainte să decizi că nu poți.
              </p>
            </div>
          </div>

          <div className="order-1 md:order-1 relative max-w-md mx-auto w-full" data-id="element-1141" data-mp="9v5gzkhpvpcj">
            {/* Diamond frame */}
            <svg className="absolute -top-12 -right-12 w-44 h-44 text-rise-gold pointer-events-none hidden md:block" viewBox="0 0 150 150" fill="none" stroke="currentColor" strokeWidth="0.7" data-id="element-1142" data-mp="ewbfy01z08ui">
              <rect x="75" y="5" width="95" height="95" rx="4" transform="rotate(45 75 52)" data-id="element-1143" data-mp="322655hlj8ca3" />
            </svg>

            {/* Starburst */}
            <svg className="absolute -top-8 -left-8 w-28 h-28 text-rise-gold/50 pointer-events-none" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-1144" data-mp="25d6ww2ky7ahw">
              <line x1="50" y1="50" x2="50" y2="5" data-id="element-1145" data-mp="2ecbv17sll1tj" />
              <line x1="50" y1="50" x2="82" y2="12" data-id="element-1146" data-mp="1qo29m6zaqg2x" />
              <line x1="50" y1="50" x2="95" y2="50" data-id="element-1147" data-mp="1qmhiysg3rhac" />
              <line x1="50" y1="50" x2="82" y2="88" data-id="element-1148" data-mp="1mn8lpdlut1a1" />
              <line x1="50" y1="50" x2="50" y2="95" data-id="element-1149" data-mp="1mkmg3jiiwvug" />
              <line x1="50" y1="50" x2="18" y2="88" data-id="element-1150" data-mp="3ls8nfdzvvhfw" />
              <line x1="50" y1="50" x2="5" y2="50" data-id="element-1151" data-mp="3lpmilm4dng1d" />
              <line x1="50" y1="50" x2="18" y2="12" data-id="element-1152" data-mp="3qpifl1enq77f" />
              <circle cx="50" cy="50" r="2.5" fill="currentColor" data-id="element-1153" data-mp="3vha4z8m2u6vz" />
            </svg>

            {/* Crosses */}
            <svg className="absolute top-8 -right-7 w-5 h-5 text-rise-gold pointer-events-none" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-1154" data-mp="4apg9vjhvb24">
              <line x1="10" y1="2" x2="10" y2="18" data-id="element-1155" data-mp="37rxzojtveiyy" />
              <line x1="2" y1="10" x2="18" y2="10" data-id="element-1156" data-mp="3cq97yq4iolf2" />
            </svg>
            <svg className="absolute bottom-12 -left-6 w-4 h-4 text-rise-gold/70 pointer-events-none" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-1157" data-mp="3ct55wegd7a3i">
              <line x1="10" y1="2" x2="10" y2="18" data-id="element-1158" data-mp="wybjv3sq2foz" />
              <line x1="2" y1="10" x2="18" y2="10" data-id="element-1159" data-mp="2hhff8cvy3ng7" />
            </svg>

            {/* Dots */}
            <div className="absolute -top-3 left-16 w-2.5 h-2.5 rounded-full bg-rise-gold pointer-events-none" data-id="element-1160" data-mp="2cim2wnsea2hm"></div>
            <div className="absolute -bottom-3 right-24 w-3 h-3 rounded-full bg-rise-gold pointer-events-none" data-id="element-1161" data-mp="27rc9rd7n0h0z"></div>

            {/* Offset borders */}
            <div className="absolute inset-0 border border-rise-gold/60 rounded-xl translate-x-5 translate-y-5 pointer-events-none" data-id="element-1162" data-mp="22qon13qfymck"></div>
            <div className="absolute inset-0 border border-rise-gold/25 rounded-xl -translate-x-3 -translate-y-3 pointer-events-none hidden md:block" data-id="element-1163" data-mp="1tscq6jyzesbo"></div>

            <img src="https://cdn.magicpatterns.com/uploads/5cTB7VyUXGVsL6aadBqWkg/Teodora_2.jpg" alt="Teodora Trifu" className="w-full h-auto md:h-[600px] object-cover object-top rounded-xl shadow-xl z-10 relative" data-id="element-1164" data-mp="1ot9sxlp8tqe9" />
          </div>
        </div>
      </section>

      {/* SECTION 5 - CTA FINAL (Light) */}
      <section className="bg-rise-white text-rise-black py-14 md:py-24 px-6 text-center relative overflow-hidden" data-id="element-1165" data-mp="2n2c2fbp8cy01">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-transparent to-rise-gold/40" data-id="element-1166" data-mp="2s0djjr33in8v"></div>
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-t from-transparent to-rise-gold/40" data-id="element-1167" data-mp="2dapov8pf6mu4"></div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-1168" data-mp="24bkt2a58t7ln">
          <h2 className="font-playfair text-[36px] md:text-[48px] text-rise-black mb-8" data-id="element-1169" data-mp="24e72ygflvz71">
            Ești gata să descoperi ce ai în tine?
          </h2>

          <div className="border border-rise-gold/40 rounded-xl p-8 md:p-10 mb-10 bg-white shadow-sm" data-id="element-1170" data-mp="1uezotr11s0iv">
            <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed italic" data-id="element-1171" data-mp="1ze2hsd3r6gah">
              Cel mai rău lucru care se poate întâmpla este să pleci din această
              sesiune știind exact ce resurse ai, cum să le folosești și cu un
              pas concret de făcut. Chiar dacă nu lucrăm împreună după aceea,
              aceste lucruri rămân ale tale pentru totdeauna.
            </p>
          </div>

          <div className="flex justify-center" data-id="element-1172" data-mp="1d6f8oht4n993">
            <a href={CTA_LINK} target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors inline-flex items-center justify-center" data-id="element-1173" data-mp="1ru0am8e9n2ff">
              Rezervă Sesiunea Ta Gratuită
            </a>
          </div>

          <p className="font-dm-sans text-[14px] text-rise-gold mt-6 tracking-wider uppercase" data-id="element-1174" data-mp="1wuo02pmujb7j">
            Doar 6 locuri noi pe lună · Rezervările se fac în ordinea
            înscrierilor
          </p>
        </div>
      </section>
    </>;
}